import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(theme => ({
  label: {
    display: "flex",
    "justify-content": "center",
    "align-items": "center",
  },
  check: {
    width: "20px",
    height: "20px",
    color: theme.textColor,
    "margin-right": 10,
  },
}));

const Checkbox = ({ value, onChange, name, label }) => {
  const classes = useStyles();

  return (
    <label htmlFor={name} className={classes.label}>
      <input
        name={name}
        className={classes.check}
        type="checkbox"
        checked={value}
        onChange={e => {
          const value = e.target.checked;
          onChange(value);
        }}
      />
      {label}
    </label>
  );
};

export default Checkbox;
